import { useEffect } from 'react';

import { useInvalidateLotPages } from '@features/buyer-line-items-pagination/api/actions';
import type { ID } from 'types';

/** Has every lot page on screen read again once a shell refresh's count has rendered, so each read reports that count. */
export const useInvalidateLotPagesOnShellRefresh = (eventId: ID | undefined, shellRefreshCount: number) => {
  const invalidateLotPages = useInvalidateLotPages();

  useEffect(() => {
    if (!shellRefreshCount || eventId === undefined) return;

    invalidateLotPages(eventId);
  }, [eventId, invalidateLotPages, shellRefreshCount]);
};
